import { gamingHistoryApiService } from "@api-services/games";
import {
	TransactionDto,
	GamingHistoryRequestFilter,
	GamingHistoryResponse,
} from "@api-types/games";

class GamingHistoryService {
	async getGamingHistoryData(
		bodyData: GamingHistoryRequestFilter
	): Promise<GamingHistoryResponse> {
		const response =
			await gamingHistoryApiService.getGamingHistoryData(bodyData);

		return response;
	}

	async getAvailableLiveGames(): Promise<string[]> {
		return await gamingHistoryApiService.getAvailableLiveGames();
	}

	async getTransactionsPerRound(
		bodyData: GamingHistoryRequestFilter
	): Promise<TransactionDto[]> {
		const response =
			await gamingHistoryApiService.getTransactionsPerRound(bodyData);

		return response.result;
	}
}

const gamingHistoryService = new GamingHistoryService();

export { gamingHistoryService };
